import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme, type ThemePreference } from '@/providers/ThemeProvider';
import { cn } from '@/lib/cn';

const options: Array<{ value: ThemePreference; label: string; Icon: typeof Sun }> = [
  { value: 'light', label: 'Light', Icon: Sun },
  { value: 'system', label: 'System', Icon: Monitor },
  { value: 'dark', label: 'Dark', Icon: Moon },
];

export function ThemeToggle({ compact }: { compact?: boolean }) {
  const { preference, setPreference } = useTheme();
  return (
    <div
      className={cn(
        'inline-flex items-center gap-0.5 rounded-full border border-border bg-surface p-0.5',
      )}
      role="radiogroup"
      aria-label="Theme"
    >
      {options.map(({ value, label, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            title={label}
            onClick={() => setPreference(value)}
            className={cn(
              'inline-flex items-center justify-center rounded-full transition',
              compact ? 'h-7 w-7' : 'h-7 w-7',
              active
                ? 'bg-primary text-primary-ink shadow-soft'
                : 'text-ink-muted hover:bg-muted hover:text-ink',
            )}
          >
            <Icon className="h-3.5 w-3.5" />
          </button>
        );
      })}
    </div>
  );
}
